import { useState } from 'react';
import { ArrowsClockwise } from '@phosphor-icons/react';
import { triggerAppRefresh } from '../../hooks/useAutoRefresh';

/**
 * Header refresh button. Explicit "reload data" without closing the PWA.
 * Dispatches the global `app:refresh` event that all data hooks listen to.
 */
export default function RefreshButton({ className = '' }) {
    const [spinning, setSpinning] = useState(false);
    const onClick = () => {
        if (spinning) return;
        setSpinning(true);
        triggerAppRefresh();
        // Just visual — the actual refresh runs immediately.
        setTimeout(() => setSpinning(false), 700);
    };
    return (
        <button
            onClick={onClick}
            title="Odśwież dane"
            aria-label="Odśwież"
            data-testid="app-refresh-btn"
            className={`w-9 h-9 flex items-center justify-center rounded-md hover:bg-muted text-muted-foreground transition-colors ${className}`}
        >
            <ArrowsClockwise
                className={`w-5 h-5 ${spinning ? 'animate-spin' : ''}`}
                weight="regular"
            />
        </button>
    );
}
